"use client";

import { useQuery } from "@tanstack/react-query";

interface TagFiltersResponse {
  tags: string[];
}

export function useUserTagFilters(enabled: boolean) {
  return useQuery<TagFiltersResponse>({
    queryKey: ["tags", "filters"],
    queryFn: async () => {
      const res = await fetch("/api/tags/filters");
      if (!res.ok) throw new Error("Failed to fetch tag filters");
      return res.json();
    },
    enabled,
  });
}
